import { render, staticRenderFns } from "./kakaoIOSReturn.vue?vue&type=template&id=88939c9c&scoped=true"
import script from "./kakaoIOSReturn.vue?vue&type=script&lang=js"
export * from "./kakaoIOSReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88939c9c",
  null
  
)

export default component.exports